import { useEffect, useState } from "react";
import GlobalSpinner from "../globalsSpinner/GlobalSpinner"
import { Button } from "../Button";
import IconButton from "../iconButton/IconButton";
import { BaseInfo, Guid } from "../../../api/baseApi";
import { RightModal, SmallModal } from "../sideModal/Modal";
import { FormInput, FormRow } from "../formRow/FormRow";
import Select, { MultiValue, SingleValue } from "react-select";
import { getPlayers } from "../../../api/playersApi";
import { createTag, CreateTagRequest, deleteTag, TagManagmentEntityRequest, deleteTagManagmentEntity, getTagManagment, TagManagmentEntityType, TagManagmentProfile, updateTag, addEntityForTag, getTagStreams, ExtendedBaseInfo } from "../../../api/tagApi";
import { getCampaigns } from "../../../api/campaingsApi";
import { getPlayNowLists } from "../../../api/playNowListApi";
import Pagination from "../pagination/Pagination";
import { getPagesCount } from "../../../services/paginator";

type ModalAction = "create" | "edit" | "nothing";
type Option<T> = { value: T, label: string}
const TagManagment = () => {
    let [isLoading, setIsLoading] = useState(false)
    let [isShowModal, setIsShowModal] = useState(false)
    let [isShowDeleteModal, setIsShowDeleteModal] = useState(false)
    let [isShowEntityDeleteModal, setIsShowEntityDeleteModal] = useState(false)
    let [isShowEntityAddModal, setIsShowEntityAddModal] = useState(false)
    let [idForAction, setIdForAction] = useState("")
    let [entityIdForAction, setEntityIdForAction] = useState("")
    let [modalAction, setModalAction] = useState<ModalAction>("nothing")

    let [tagName, setTagName] = useState("")
    let [isTagNameError, setIsTagNameError] = useState(false)

    let [tagProfiles, setTagProfiles] = useState<TagManagmentProfile[]>([])
    let [listItemsToDisplay, setListItemsToDisplay] = useState<TagManagmentProfile[]>([]);

    let [players, setPlayers] = useState<Option<Guid>[]>([]);
    let [selectedPlayers, setSelectedPlayers] = useState<Guid[]>([])
    let [currentPlayer, setCurrentPlayer] = useState<Guid>("")

    let [campaigns, setCampaigns] = useState<Option<Guid>[]>([]);
    let [selectedCampaigns, setSelectedCampaigns] = useState<Guid[]>([])
    let [currentCampaign, setCurrentCampaign] = useState<Guid>("")

    let [streams, setStreams] = useState<Option<Guid>[]>([]);
    let [selectedStreams, setSelectedStreams] = useState<Guid[]>([])
    let [currentStream, setCurrentStream] = useState<Guid>("")

    let [playNows, setPlayNows] = useState<Option<Guid>[]>([]);
    let [selectedPlayNows, setSelectedPlayNows] = useState<Guid[]>([])
    let [currentPlayNow, setCurrentPlayNow] = useState<Guid>("")

    let [entityType, setEntityType] = useState<TagManagmentEntityType | null>(null)

    let [searchString, setSearchString] = useState("")
    let [pageLoaded, setPageLoaded] = useState(false)

    let [currentPage, setCurrentPage] = useState<number>(1);
    let itemsPerPage = 20;

    useEffect(()=>{
        async function fetchTagManagment(){
            setIsLoading(true);
            await Promise.all([updateTagManagmentList(), updatePlayersList(), updateCampaigns(), updateStreams(), updatePlayNows()]);
            setPageLoaded(true);
            setIsLoading(false);
        }

        fetchTagManagment()
    },[])

    useEffect(()=>{
        let interval = setTimeout(()=> {
            if(pageLoaded){
                updateTagManagmentList();
                setCurrentPage(1)
            } 
        }, 1000)

        return () => {
            clearTimeout(interval)
        }
    },[searchString])

    useEffect(()=>{
        if(pageLoaded){
            updateTagManagmentList();
            setCurrentPage(1)
        } 
    },[selectedPlayers, selectedCampaigns, selectedPlayNows, selectedStreams])

    useEffect(() => {
        let startIndex = (currentPage - 1)*itemsPerPage;
        let finishIndex = startIndex + itemsPerPage;
        setListItemsToDisplay(tagProfiles.slice(startIndex, finishIndex));
    }, [tagProfiles, currentPage]);

    const updateTagManagmentList = async () => {
        let response = await getTagManagment({
            searchString: searchString,
            playerIds: selectedPlayers,
            campaignIds: selectedCampaigns,
            playNowIds: selectedPlayNows,
            streamIds: selectedStreams
        });
        if( response.type === "succes") {
            setTagProfiles(response.data.items);
        }
    }

    const updatePlayersList = async () => {
        let result = await getPlayers();
        setPlayers(result.players.map(player => {
            return {
                label: player.name ? player.name : '',
                value: player.id
            }
        }));
    }

    const updateCampaigns = async () => {
        let result = await getCampaigns()
        if(result.type === "succes"){
            setCampaigns(result.data.campaigns.map(el => {
                return {
                    label: el.name,
                    value: el.id
                }
            }))
        }
    }

    const updateStreams = async () => {
        let result = await getTagStreams()
        if(result.type === "succes"){
            setStreams(result.data.items.map(el => {
                return {
                    label: el.name,
                    value: el.id
                }
            }))
        }
    }

    const updatePlayNows = async () => {
        var result = await getPlayNowLists();
        if(result.type === 'succes'){
            setPlayNows(result.data.items.map(el => {
                return {
                    label: el.name,
                    value: el.id
                }
            }));
        }
    }

    const renderBaseInfo = (arr: ExtendedBaseInfo[], tagId: Guid, entity: TagManagmentEntityType) => {
        return arr.map( el => {
            return <p key={el.id}>
                {el.name} &nbsp; 
                {el.isAny ? <span className="green-text" >Any</span> : null}&nbsp;
                <span className="close__element" onClick={()=>{showEntityDeleteModal(tagId, el.id, entity)}}>x</span>
            </p>
        })
    }
    
    const renderProfilesList = (profiles:TagManagmentProfile[]) => {
        return profiles.map( it => {
            return <tr key={it.id}>
                <td>{it.name}</td>
                <td>
                    {renderBaseInfo(it.players, it.id, TagManagmentEntityType.Players)}
                    <p className="link-like__elem" onClick={() => {showEntityAddModal(it.id, TagManagmentEntityType.Players)}}>+ Add</p>
                </td>
                <td>
                    {renderBaseInfo(it.campaigns, it.id, TagManagmentEntityType.Campaigns)}
                    <p className="link-like__elem" onClick={() => {showEntityAddModal(it.id, TagManagmentEntityType.Campaigns)}}>+ Add</p>
                </td>
                <td>
                    {renderBaseInfo(it.includedStreams, it.id, TagManagmentEntityType.IncludedStreams)}
                    <p className="link-like__elem" onClick={() => {showEntityAddModal(it.id, TagManagmentEntityType.IncludedStreams)}}>+ Add</p>
                </td>
                <td>
                    {renderBaseInfo(it.excludedStreams, it.id, TagManagmentEntityType.ExcludedStreams)}
                    <p className="link-like__elem" onClick={() => {showEntityAddModal(it.id, TagManagmentEntityType.ExcludedStreams)}}>+ Add</p>
                </td>
                <td>
                    {renderBaseInfo(it.includedPlayNows, it.id, TagManagmentEntityType.IncludedPlayNows)}
                    <p className="link-like__elem" onClick={() => {showEntityAddModal(it.id, TagManagmentEntityType.IncludedPlayNows)}}>+ Add</p>
                </td>
                <td>
                    {renderBaseInfo(it.excludedPlayNows, it.id, TagManagmentEntityType.ExcludedPlayNows)}
                    <p className="link-like__elem" onClick={() => {showEntityAddModal(it.id, TagManagmentEntityType.ExcludedPlayNows)}}>+ Add</p>
                </td>
                <td>
                    <IconButton tooltipText="Edit" type="edit" onClick={() => {showModal("edit", it)}} />
                    <IconButton tooltipText="Delete" type="delete" onClick={() => {showDeleteModal(it.id)}} />
                </td>
            </tr>
        })
    }

    const showModal = (action: ModalAction, tag?: TagManagmentProfile) => {
        setIsShowModal(true);
        setModalAction(action)

        if(action === "edit" && tag){
            setTagName(tag.name)
            setIdForAction(tag.id)
        }
    }

    const hideModal = () => {
        setIsShowModal(false);
        setTagName("")
        setIsTagNameError(false)
        setModalAction("nothing")
        setIdForAction("")
    }

    const showDeleteModal = (id:Guid) => {
        setIsShowDeleteModal(true);
        setIdForAction(id);
    }

    const hideDeleteModal = () => {
        setIsShowDeleteModal(false);
        setIdForAction("");
    }

    const showEntityDeleteModal = (tagId: Guid, entityId: Guid, entity: TagManagmentEntityType) => {
        setIsShowEntityDeleteModal(true);
        setEntityType(entity);
        setIdForAction(tagId)
        setEntityIdForAction(entityId)
    }

    const hideEntityDeleteModal = () => {
        setIsShowEntityDeleteModal(false);
        setEntityType(null)
        setIdForAction("")
        setEntityIdForAction("")
    }

    const showEntityAddModal = (tagId: Guid, entity: TagManagmentEntityType) => {
        setIsShowEntityAddModal(true);
        setEntityType(entity);
        setIdForAction(tagId)
    }

    const hideEntityAddModal = () => {
        setIsShowEntityAddModal(false);
        setEntityType(null)
        setIdForAction("")
        setEntityIdForAction("")
        setCurrentPlayer("")
        setCurrentCampaign("")
        setCurrentStream("")
        setCurrentPlayNow("")
    }

    const createOrUpdateTag = async () => {
        let isValid = true;

        if(!tagName){
            setIsTagNameError(true);
            isValid = false;
        }

        if(!isValid) return;

        let request: CreateTagRequest = {
            name: tagName
        }

        setIsLoading(true)
        if( modalAction === "edit" ) {
            await updateTag(idForAction, request)
        }

        if( modalAction === "create" ) {
            await createTag(request);
        }

        await updateTagManagmentList();
        hideModal();
        setIsLoading(false);
    }

    const removeTag = async () => {
        setIsLoading(true)
        await deleteTag(idForAction)
        await updateTagManagmentList();
        setIsLoading(false)
        hideDeleteModal()
    }

    const addEntity = async () => {
        let request
        if(entityType === TagManagmentEntityType.Players){
            request = {
                entityType: entityType,
                entityId: currentPlayer,
                tagId: idForAction
            }
        }
        if(entityType === TagManagmentEntityType.Campaigns){
            request = {
                entityType: entityType,
                entityId: currentCampaign,
                tagId: idForAction
            }
        }
        if(entityType === TagManagmentEntityType.IncludedStreams){
            request = {
                entityType: entityType,
                entityId: currentStream,
                tagId: idForAction
            }
        }
        if(entityType === TagManagmentEntityType.ExcludedStreams){
            request = {
                entityType: entityType,
                entityId: currentStream,
                tagId: idForAction
            }
        }
        if(entityType === TagManagmentEntityType.IncludedPlayNows){
            request = {
                entityType: entityType,
                entityId: currentPlayNow,
                tagId: idForAction
            }
        }
        if(entityType === TagManagmentEntityType.ExcludedPlayNows){
            request = {
                entityType: entityType,
                entityId: currentPlayNow,
                tagId: idForAction
            }
        }
        
        if(request){
            setIsLoading(true)
            await addEntityForTag(request)
            await updateTagManagmentList();
            setIsLoading(false)
            hideEntityAddModal()
        }
    }

    const removeEntity = async () => {
        if(entityType){
            let request = {
                entityType: entityType,
                entityId: entityIdForAction,
                tagId: idForAction
            }
            setIsLoading(true)
            await deleteTagManagmentEntity(request)
            await updateTagManagmentList();
            setIsLoading(false)
            hideEntityDeleteModal()
        }
    }

    const onChangeSelectedPlayers = (values: MultiValue<Option<Guid>>) => {
        let ids = values.map(it => it.value);
        setSelectedPlayers([...ids]);
    }

    const onChangeCurrentPlayer = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setCurrentPlayer(value.value);
        } else setCurrentPlayer("")
    }

    const onChangeSelectedCampaigns = (values: MultiValue<Option<Guid>>) => {
        let ids = values.map(it => it.value);
        setSelectedCampaigns([...ids]);
    }

    const onChangeCurrentCampaign = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setCurrentCampaign(value.value);
        } else setCurrentCampaign("");
    }

    const onChangeSelectedStreams = (values: MultiValue<Option<Guid>>) => {
        let ids = values.map(it => it.value);
        setSelectedStreams([...ids]);
    }

    const onChangeCurrentStream = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setCurrentStream(value.value);
        } else setCurrentStream("");
    }

    const onChangeSelectedPlayNows = (values: MultiValue<Option<Guid>>) => {
        let ids = values.map(it => it.value);
        setSelectedPlayNows([...ids]);
    }

    const onChangeCurrentPlayNow = (value: SingleValue<Option<Guid>>) => {
        if(value){
            setCurrentPlayNow(value.value)
        } else setCurrentPlayNow("");
    }

    return <>
        <div className="d-flex justify-content-between align-items-center mb-20 w-100">
            <h2>Tag Management</h2>
            <Button color="green"  label="Add Tag" onClick={() => {showModal("create")}} />
        </div>

        <div className="d-flex justify-content-between align-items-center gap15">
            <FormRow>
                <FormInput 
                    errorMessage = ""
                    id = "tag_search"
                    isError = {false}
                    title = "Search"
                    onChangeValue = {(v) => {setSearchString(v);}}
                    value = {searchString}
                /> 
            </FormRow>

            <FormRow>
                <label>Players</label>
                <Select 
                    classNamePrefix={`select`}
                    options={players} 
                    isMulti={true}
                    onChange={onChangeSelectedPlayers}
                />    
            </FormRow>

            <FormRow>
                <label>Campaigns</label>
                <Select 
                    classNamePrefix={`select`}
                    options={campaigns} 
                    isMulti={true}
                    onChange={onChangeSelectedCampaigns}
                />    
            </FormRow>

            <FormRow>
                <label>Streams</label>
                <Select 
                    classNamePrefix={`select`}
                    options={streams} 
                    isMulti={true}
                    onChange={onChangeSelectedStreams}
                />    
            </FormRow>

            <FormRow>
                <label>PlayNow</label>
                <Select 
                    classNamePrefix={`select`}
                    options={playNows} 
                    isMulti={true}
                    onChange={onChangeSelectedPlayNows}
                />    
            </FormRow>

            
        </div>

        {listItemsToDisplay.length ? <><table className="table">
            <thead>
                <tr>
                    <td>Name</td>
                    <td>Players</td>
                    <td>Campaigns</td>
                    <td>Streams Include</td>
                    <td>Streams Exclude</td>
                    <td>PlayNow Include</td>
                    <td>PlayNow Exclude</td>
                    <td></td>
                </tr>
            </thead>
            <tbody>
                {renderProfilesList(listItemsToDisplay)}
            </tbody>
        </table>
        <Pagination activePage={currentPage} pagesCount={getPagesCount(tagProfiles.length, itemsPerPage)} changePaginationPage={setCurrentPage} />
        </> : <p>Element list is empty</p>}


        <RightModal title={`${modalAction === "edit" ? "Edit" : "Add New"} Tag`} show={isShowModal} onRequestClose={hideModal}>
            <FormRow>
                <FormInput 
                    errorMessage = "Please enter Name"
                    id = "tag_name"
                    isError = {isTagNameError}
                    title = "Name"
                    onChangeValue = {(v) => {setTagName(v); setIsTagNameError(false)}}
                    value = {tagName}
                />
            </FormRow>

            <div className="modal-btn-group">
                <Button color="green" label="Save" onClick={createOrUpdateTag}/>
                <Button color="gray" label="Cancel" onClick={hideModal}/>
            </div>
        </RightModal>  

        <RightModal title="Add" show={isShowEntityAddModal} onRequestClose={hideEntityAddModal}>
            {entityType === TagManagmentEntityType.Players && <FormRow>
                <label>Players</label>
                <Select 
                    classNamePrefix={`select`}
                    options={players} 
                    onChange={onChangeCurrentPlayer}
                /> 
            </FormRow>}
            {entityType === TagManagmentEntityType.Campaigns && <FormRow>
                <label>Campaigns</label>
                <Select 
                    classNamePrefix={`select`}
                    options={campaigns} 
                    onChange={onChangeCurrentCampaign}
                /> 
            </FormRow>}
            {(entityType === TagManagmentEntityType.IncludedStreams || entityType === TagManagmentEntityType.ExcludedStreams) && <FormRow>
                <label>Streams</label>
                <Select 
                    classNamePrefix={`select`}
                    options={streams} 
                    onChange={onChangeCurrentStream}
                /> 
            </FormRow>}
            {(entityType === TagManagmentEntityType.IncludedPlayNows || entityType === TagManagmentEntityType.ExcludedPlayNows) && <FormRow>
                <label>PlayNows</label>
                <Select 
                    classNamePrefix={`select`}
                    options={playNows} 
                    onChange={onChangeCurrentPlayNow}
                /> 
            </FormRow>}

            <div className="modal-btn-group">
                <Button color="green" label="Save" onClick={addEntity}/>
                <Button color="gray" label="Cancel" onClick={hideEntityAddModal}/>
            </div>
        </RightModal>  
        
        <SmallModal show={isShowDeleteModal} onRequestClose={hideDeleteModal}> 
            <p>That you want to delete Tag?</p>
            <div className="modal-btn-group">
                <Button color="gray" label="Cancel" onClick={hideDeleteModal}/>
                <Button color="green" label="Yes" onClick={removeTag}/>
            </div>
        </SmallModal>

        <SmallModal show={isShowEntityDeleteModal} onRequestClose={hideEntityDeleteModal}> 
            <p>That you want to delete {entityType && TagManagmentEntityType[entityType].slice(0, -1)} ?</p>
            <div className="modal-btn-group">
                <Button color="gray" label="Cancel" onClick={hideEntityDeleteModal}/>
                <Button color="green" label="Yes" onClick={removeEntity}/>
            </div>
        </SmallModal>

        <GlobalSpinner isShow={isLoading} />
    </>
}

export default TagManagment